import type { FormControlProps } from 'react-bootstrap';
import { FormControl } from 'react-bootstrap';
import Flex from './Flex';
import Icon, { icons } from './Icon';

const styles = {
  wrapper: {
    borderRadius: '4px',
    border: '1px solid #ccc',
    padding: '0 8px',
    width: '100%',
  },
  input: {
    border: 0,
  },
};

/**
 * @deprecated Use Forms/SearchInput instead.
 */
const SearchInput = (props: FormControlProps) => (
  <div style={styles.wrapper}>
    <Flex justify="flex-start">
      <Icon icon={icons.search} />
      <FormControl
        type="text"
        placeholder={props.placeholder || 'Search...'}
        style={styles.input}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
    </Flex>
  </div>
);

export default SearchInput;
